export default function (rawBalance, decimals, price) {
    const totalValue = rawBalance.shiftedBy(-decimals).multipliedBy(price.usd);
    return {
        total: totalValue,
        display: '$' + Math.round(totalValue.toNumber()).toLocaleString('en')
    };
}
